module.exports = __webpack_public_path__ + "static/media/icon-google-play-alt.6cbc79d6.svg";